<template>
  <div id="app">

    <div class="top-nav">

      <div class="top-nav-item">
        <!-- API key -->
        <form v-on:submit.prevent="applyApiKey()" v-show="showApiKey">
          <input class="api-key-input" v-model="apiKey" size="55" placeholder="API Key"/>
          <button type="submit">Apply</button>
        </form>
        <div v-show="!showApiKey">
          <button @click="changeApiKey">Change</button>
        </div>
        <div v-if="partner.name" class="apiKeyAccount">
          {{ partner.name }}
        </div>
        <div v-else class="apiKeyAccount">
          {{ account.name }}
        </div>
      </div>

      <div class="top-nav-item">
        <!-- Account -->
        <div id="account" v-show="partner.id">
          <label for="accountSelect">Account:</label>
          <select id="accountSelect" v-model="account">
            <option v-for="account in accounts" :key="account.id" :value="account">{{ account.name }}</option>
          </select>
          <!-- <pre v-show="debugMode">{{account}}</pre> -->
        </div>

        <!-- Profile -->
        <div id="profile" v-show="profiles.length > 1">
          <label for="profileSelect">Profile:</label>
          <select id="profileSelect" v-model="profile">
            <option v-for="profile in profiles" :key="profile.id" :value="profile">{{ profile.name }}</option>
          </select>
          <!-- <pre v-show="debugMode">{{profile}}</pre> -->
        </div>
      </div>

      <!-- Debug mode -->
      <div class="top-nav-item">
        <input type="checkbox" id="debugMode" v-model="debugMode">
        <label for="debugMode">Debug mode</label>
      </div>

    </div>

    <router-link class="router-link" to="/">Dashboard</router-link>
    <router-link class="router-link" to="/assets">Assets</router-link>
    <router-link class="router-link" to="/alerts">Alerts</router-link>
    <router-link class="router-link" to="/vulnerabilities">Vulnerabilities</router-link>
    <router-link class="router-link" to="/profiles">Profiles</router-link>
    <router-view/>
  </div>
</template>

<style>
select {
  margin-right:5px;
}
label {
  margin-right:5px;
}
pre {
  margin: 0px;
  padding: 5px;
  max-width: 100%;
  color: #333;
  background-color: wheat;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 5px;
}
#account {
  font-size: 18px;
}
#account > select {
  font-size: 18px;
}
#profile {
  font-size: 18px;
}
#profile > select {
  font-size: 18px;
}
.apiKeyAccount {
  margin-left: 5px;
  font-size: 18px;
}
.top-nav {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.top-nav-item {
   display: flex;
   text-align: left;
}
.api-key-input {
  margin-right: 5px;
}
.router-link {
  margin-right: 5px;
}
.router-link-exact-active {
  font-size: 26px;
}
.page {
  margin-top: 20px;
  margin-left: 20%;
  margin-right: 20%;
  text-align: left;
}
.bordered {
  margin-top: 5px;
  padding: 5px;
  border-radius: 5px;
  border: 1px solid #cccccc;
}
.debug {
  font-size: 10px;
  background-color: white !important;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
  name: 'App',
  computed: {
    debugMode: {
      get(){return this.$store.state.debugMode},
      set(val){this.$store.commit('setDebugMode', val)}
    },
    account: {
      get(){return this.$store.state.account},
      set(val){this.$store.dispatch('selectAccount', val)}
    },
    profile: {
      get(){return this.$store.state.profile},
      set(val){this.$store.dispatch('selectProfile', val)}
    },
    ...mapState([
      'partner',
      'accounts',
      'profiles',
    ])
  },
  methods: {
    applyApiKey () {
      localStorage.setItem('apiKey', this.apiKey)
      this.$store.dispatch('setApiKey', this.apiKey)
      this.showApiKey = false
    },
    changeApiKey () {
      this.showApiKey = true
    }
  },
  data () {
    return {
      showApiKey: false,
      apiKey: localStorage.getItem('apiKey')
    }
  },
  mounted () {
    if (this.apiKey)
      this.applyApiKey()
    else
      this.showApiKey = true
  }
}
</script>
